<form *ngIf="form && formGroupName" [formGroup]="form" class="w-100">
  <mat-checkbox color="primary" class="w-100" [formControlName]="formGroupName">{{ label }}</mat-checkbox>
</form>
